export var ZTCStateFlags;
(function (ZTCStateFlags) {
    ZTCStateFlags[ZTCStateFlags["MAIN_POWER"] = 1] = "MAIN_POWER";
    ZTCStateFlags[ZTCStateFlags["USB_POWER"] = 2] = "USB_POWER";
    ZTCStateFlags[ZTCStateFlags["CONNECTION_VIA_GSM"] = 4] = "CONNECTION_VIA_GSM";
    ZTCStateFlags[ZTCStateFlags["CONNECTION_VIA_WIFI"] = 8] = "CONNECTION_VIA_WIFI";
    ZTCStateFlags[ZTCStateFlags["CONNECTION_VIA_ETHERNET"] = 16] = "CONNECTION_VIA_ETHERNET";
})(ZTCStateFlags || (ZTCStateFlags = {}));
